import React from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Meetings from './pages/Meetings';
import Events from './pages/Events';
import Sermons from './pages/Sermons';
import Contact from './pages/Contact';
import Donate from './pages/Donate';

function App() {
  return (
    <div className="app-root">
      <Header />
      <main>
        <section id="home" className="site-section">
          <Home />
        </section>
        <section id="about" className="site-section">
          <About />
        </section>
        <section id="meetings" className="site-section">
          <Meetings />
        </section>
        <section id="events" className="site-section">
          <Events />
        </section>
        <section id="sermons" className="site-section">
          <Sermons />
        </section>
        <section id="contact" className="site-section">
          <Contact />
        </section>
        <section id="donate" className="site-section">
          <Donate />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;
